<template>
  <div>
    <router-view />
    <v-bottom-sheet
      inset
      persistent
      v-model="analyticsSheet"
      @click:outside="outsideClick"
    >
      <v-sheet>
        <div class="analytics-notice">
          <div>
            This website uses cookies, Google Analytics, as well as similar
            tools and technologies to understand visitors’ experiences. By
            continuing to use this website, you consent to Duke University’s
            usage of cookies and similar technologies, in accordance with the
            <a
              class="privacy-link"
              href="https://oarc.duke.edu/privacy/duke-university-privacy-statement"
              target="_blank"
              >Duke&nbsp;Privacy&nbsp;Statement</a
            >.
          </div>
          <v-btn class="accept-button" text @click="acceptAnalytics">
            I Accept
          </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data: () => ({
    //
    analyticsSheet: true,
    analyticsAccepted: null
  }),
  methods: {
    outsideClick() {
      // console.log("outside");
    },
    async acceptAnalytics() {
      this.$ga.enable();
      this.analyticsSheet = false;
      this.$store.set("analyticsOn", true);
      await localStorage.setItem("ANALYTICS_ACCEPTED", true);
    }
  },
  mounted() {
    this.analyticsAccepted = JSON.parse(
      localStorage.getItem("ANALYTICS_ACCEPTED")
    );
    if (this.analyticsAccepted) {
      this.$ga.enable();
      this.analyticsSheet = false;
    } else {
      this.analyticsSheet = true;
    }

    localStorage.setItem("WELCOME_VIEWED", true);
  }
};
</script>

<style scoped>
.privacy-link {
  color: white;
  font-weight: 700;
  text-decoration: none;
}

@media (min-width: 0px) {
  .analytics-notice {
    background-color: rgb(0, 26, 87);
    color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    padding: 20px;
    align-items: center;
  }

  .accept-button {
    background-color: rgb(255, 217, 96);
    font-weight: 900;
    color: black;
    margin-left: 0px;
    margin-top: 20px;
  }
}

@media (min-width: 800px) {
  .analytics-notice {
    background-color: rgb(0, 26, 87);
    color: rgb(255, 255, 255);
    display: flex;
    flex-direction: row;
    padding: 20px;
    align-items: center;
  }

  .accept-button {
    background-color: rgb(255, 217, 96);
    font-weight: 900;
    color: black;
    margin-left: 20px;
    margin-top: 0px;
  }
}
</style>
